/* eslint-disable no-unused-vars */
import React from 'react';
import { Box, Grid, Typography } from '@mui/material';

const Partners = () => {
    return (
        <Box>
            <Box marginBottom={5} textAlign="center">
                <Typography
                    sx={{
                        textTransform: 'uppercase',
                        fontWeight: 600,
                        letterSpacing: '0.1em',
                        fontSize: '0.875rem',
                    }}
                    gutterBottom
                    color={'secondary'}
                >
                    Trusted By Industry Leaders
                </Typography>
                <Box
                    component={Typography}
                    fontWeight={800}
                    variant={'h2'}
                    gutterBottom
                    sx={{
                        fontSize: { xs: '2rem', md: '3rem' },
                        lineHeight: 1.2,
                    }}
                >
                    Clients We Serve
                </Box>
                <Typography
                    variant={'h6'}
                    component={'p'}
                    color={'textSecondary'}
                    sx={{
                        maxWidth: '700px',
                        margin: '0 auto',
                        lineHeight: 1.7,
                    }}
                >
                    We partner with forward-thinking organizations to deliver 
                    transformative technology solutions.
                </Typography>
            </Box>
            <Box>
                <Grid
                    container
                    spacing={6}
                    alignItems="center"
                    justifyContent="center"
                    sx={{
                        '& img': {
                            transition: 'all 0.3s ease-in-out',
                            '&:hover': {
                                transform: 'scale(1.05)',
                            },
                        },
                    }}
                >
                    <Grid item>
                        <Box
                            component="img"
                            src="/assets/parkliio.png"
                            alt="Parkliio - Client of Burns Consulting Partners"
                            loading="lazy"
                            sx={{
                                height: { xs: '30px', md: '40px' },
                                width: 'auto',
                            }}
                        />
                    </Grid>
                    <Grid item>
                        <Box
                            component="img"
                            src="/assets/ratemylandlord.png"
                            alt="Rate My Landlord - Client of Burns Consulting Partners"
                            loading="lazy"
                            sx={{
                                height: { xs: '30px', md: '40px' },
                                width: 'auto',
                            }}
                        />
                    </Grid>
                    <Grid item>
                        <Box
                            component="img"
                            src="/assets/steamhouse.png"
                            alt="Steamhouse - Client of Burns Consulting Partners"
                            loading="lazy"
                            sx={{
                                height: { xs: '80px', md: '100px' },
                                width: 'auto',
                            }}
                        />
                    </Grid>
                    <Grid item>
                        <Box
                            component="img"
                            src="/assets/krisp.png"
                            alt="Krisp - Client of Burns Consulting Partners"
                            loading="lazy"
                            sx={{
                                height: { xs: '40px', md: '50px' },
                                width: 'auto',
                            }}
                        />
                    </Grid>
                </Grid>
            </Box>
        </Box>
    );
};

export default Partners;
